const getters = {
  token: (state) => state.user.token,
  user_id: (state) => state.user.id,
  loginIdent: (state) => state.user.loginIdent,
  user_name: (state) => state.user.name,
  user_mobile: (state) => state.user.profile.user_mobile,
  avatar: (state) => state.user.avatar,
  msgNumber: (state) => state.user.msgNumber,
  isLogin: (state) => state.user.isLogin,
  isAuth: (state) => state.user.isAuth,
  searchHistory: (state) => state.user.searchHistory,
  hotSearch: (state) => state.public.hotSearch,
};
export default getters;
